import { render, staticRenderFns } from "./RequisitionStatusDisplay.vue?vue&type=template&id=6cf16215&"
import script from "./RequisitionStatusDisplay.vue?vue&type=script&lang=ts&"
export * from "./RequisitionStatusDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports